// extracted by mini-css-extract-plugin
export default {"pageTitle":"PageTitle_pageTitle__-k0Bx"};